import { render, staticRenderFns } from "./tag_pills.vue?vue&type=template&id=57e7a2da&"
import script from "./tag_pills.vue?vue&type=script&lang=js&"
export * from "./tag_pills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports